const SET_COUPON_DATA = 'SET_COUPON_DATA'
const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB'
const SET_SELECT_CODE = 'SET_SELECT_CODE'
const SET_REFERRER_DATA = 'SET_REFERRER_DATA'

const state = {
  couponCode: '',
  getActiveTab:'',
  selectCode:'',
  referData:''//vip discount referer
}

const mutations = {
  [SET_REFERRER_DATA]: (state, value) => {
    state.referData = value
  },
  [SET_COUPON_DATA]: (state, value) => {
    state.couponCode = value
  },
  [SET_SELECT_CODE]: (state, value) => {
    state.selectCode = value
  },
  [SET_ACTIVE_TAB]: (state, value) => {
    state.getActiveTab = value
  },
}

const actions = {
  setReferrerData({ commit }, val) {
    commit(SET_REFERRER_DATA, val)
  },
  setCouponData({ commit }, val) {
    commit(SET_COUPON_DATA, val)
  },
  setSelectCode({ commit }, val) {
    commit(SET_SELECT_CODE, val)
  },
  setActiveTab({ commit }, val) {
    commit(SET_ACTIVE_TAB, val)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
